export default __webpack_public_path__ + "assets/yemen-flag.png";